export default __webpack_public_path__ + "static/media/hbs-k-blk-1.c2d097e5.png";